<template>
    <div class="ah-page accounting-general-ledger-empty">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <el-button type="dark-transparent" icon="el-icon-back" @click="onBackToList">返回</el-button>
                        <h1 style="display: inline-block; vertical-align: middle; margin-left: 20px">空白科目傳票項目列表</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px; margin-bottom: -32px">
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-body">
                        <search-form>
                            <search-form-item label="所屬傳票年份">
                                <div style="display: flex; gap: 12px">
                                    <el-select v-model="queryParams.Year" @change="updateData" style="width: 150px">
                                        <el-option v-for="year in yearList" :key="year.value" :value="year.value" :label="year.label"></el-option>
                                    </el-select>
                                    <el-button icon="el-icon-refresh" @click="updateData">重新整理</el-button>
                                </div>
                            </search-form-item>
                        </search-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 40px">
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-body" style="padding: 30px 50px">
                        <el-alert v-if="datas.length > 0" type="warning" :closable="false" style="margin-bottom: 30px; padding-top: 5px">
                            <i class="el-icon-warning"></i>
                            <span> 請處理完以下所有「未設定會計科目」的項目，以確保會計報表統計正確。</span>
                        </el-alert>
                        <ah-sticky-el-table-header>
                            <el-table :data="datas" v-loading="isLoading" empty-text="無資料" size="small" class="accounting-general-ledger-empty-table">
                                <el-table-column prop="dat" label="傳票日期" width="105">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.dat">{{ getChtDate(scope.row.dat) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="serialNumber" label="傳票號碼" width="110">
                                    <template slot-scope="scope">
                                        <el-button v-if="scope.row.serialNumber" type="text" @click="onVonoClick(scope.row.vono)">{{ scope.row.serialNumber }}</el-button>
                                        <div v-else style="padding: 8px 0; cursor: default">--</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="content" label="摘要" show-overflow-tooltip />
                                <el-table-column prop="crD_NTD" label="借方金額" width="130" align="right">
                                    <template slot-scope="scope">
                                        <Money :v="scope.row.crD_NTD" v-if="scope.row.crD_NTD !== 0" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="deB_NTD" label="貸方金額" width="130" align="right">
                                    <template slot-scope="scope">
                                        <Money :v="scope.row.deB_NTD" v-if="scope.row.deB_NTD !== 0" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </ah-sticky-el-table-header>
                    </div>
                </div>
            </div>
        </div>
        <VoucherDetail :visible="voucherDetail.visible" :vono="voucherDetail.vono" @close="onVoucherDetailCLose" />
    </div>
</template>

<script>
import moment from 'moment';
import VoucherDetail from '@/components/dashboard/Accounting/AccountingVoucherList/ui/VoucherDetail.vue';
import ahStickyElTableHeader from '@/components/ui/ahStickyElTableHeader.vue';
import SearchForm from '@/components/ui/SearchForm/SearchForm.vue';
import SearchFormItem from '@/components/ui/SearchForm/SearchFormItem.vue';

export default {
    name: 'AccountingGeneralLedgerEmpty',
    components: {
        VoucherDetail,
        ahStickyElTableHeader,
        SearchForm,
        SearchFormItem,
    },
    data() {
        return {
            isLoading: false,
            queryParams: { Year: new Date().getFullYear() },
            voucherDetail: {
                visible: false,
                transactionType: null,
                vono: null,
            },
            datas: [],
            totalDataCount: 0,
            emptyCount: 0,
            openDate: null,
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        yearList() {
            const currYear = new Date().getFullYear();
            const years = [];
            for (let y = currYear + 1; y >= 2020; y -= 1) {
                years.push({ label: `${y - 1911} 年`, value: y });
            }
            return years;
        },
    },
    methods: {
        async init() {
            await this.$store.dispatch('accounting/updateAccountingSettings');
            this.queryParams.Year = +this.$route.query.year + 1911 || moment().year();
            await this.updateData();
        },
        async updateData() {
            this.isLoading = true;
            try {
                const resp = await this.$api({
                    url: '/AccountingSummaryReport/QueryGeneralLedgerNullAccno',
                    method: 'GET',
                    params: this.queryParams,
                });

                console.log('QueryGeneralLedgerNullAccno', resp.data);
                this.datas = this.normalizeDataForDisplay(resp.data.items);
                this.totalDataCount = resp.data.totalNum;
                // this.emptyCount = resp.data.emptyNum;
            } finally {
                this.isLoading = false;
            }
        },
        onVonoClick(vono, transactionType) {
            this.voucherDetail.visible = true;
            this.voucherDetail.vono = vono;
            this.voucherDetail.transactionType = transactionType;
        },
        onVoucherDetailCLose(refresh) {
            this.voucherDetail.visible = false;
            this.voucherDetail.vono = null;
            this.voucherDetail.transactionType = null;
            if (refresh) {
                this.updateData();
            }
        },
        // 將資料格式化為符合總分類帳的資料格式：
        // 科目代號＆名稱只出現在第一筆
        normalizeDataForDisplay(rawItems) {
            const outputList = [];

            let lastAccno = null;
            for (let i = 0; i < rawItems?.length; i += 1) {
                const rawItem = rawItems[i];
                if (lastAccno !== rawItem.accno) {
                    // 是第一次遇到該科目
                    rawItem.firstAccno = true;
                    outputList.push(rawItem);
                    lastAccno = rawItem.accno;
                } else {
                    // 非第一次
                    const item = rawItem;
                    item.firstAccno = false;
                    outputList.push(item);
                }
            }
            return outputList;
        },
        rowClassName({ row }) {
            if (row.firstAccno) return 'first-accno-row';
            return 'normal-accno-row';
        },
        getChtDate(timestamp) {
            return `${moment(timestamp).year() - 1911}-${moment(timestamp).format('MM-DD')}`;
        },
        onBackToList() {
            this.$router.push({
                name: 'accounting-general-ledger',
                query: {
                    StartDate: +moment().year(+this.queryParams.Year).startOf('year').format('x'),
                    EndDate: +moment().year(+this.queryParams.Year).endOf('year').format('x'),
                },
            });
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.accounting-general-ledger-empty {
    &.ah-page {
        padding-bottom: 15px;
    }

    .accounting-general-ledger-empty-table {
        border-bottom: 1px solid #ddd;

        .el-table__row td {
            color: #000;
            font-size: 10pt;
            padding-top: 0;
            padding-bottom: 0;
            border-top: 1px solid #ddd;
            border-bottom: 0;
        }
    }
}
</style>
